import { Alert } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import { formatShortDate } from "@/utils/formatDate.js";

/**
 * El aviso de que los folios sin usar están por caducar.
 *
 * Aparece a 30 días y va subiendo de tono a 7 y a 1, que es lo que pide la
 * tarjeta. Es informativo: no bloquea nada ni se puede cerrar por error, porque
 * lo que está en juego son folios que el usuario ya pagó.
 *
 * Lo que vence son los folios sin usar. Las facturas ya pedidas y sus CFDI se
 * conservan siempre, y el texto lo dice para que nadie entienda otra cosa.
 */
const FolioExpiryNotice = ({ expiration }) => {
  const { t } = useTranslation();

  if (!expiration || expiration.daysLeft > 30 || expiration.folios < 1) {
    return null;
  }

  const { daysLeft, folios, expiresAt } = expiration;
  const variant = daysLeft <= 1 ? "danger" : daysLeft <= 7 ? "warning" : "info";

  return (
    <Alert variant={variant} className="d-flex align-items-start gap-2">
      <i className="bi bi-hourglass-split mt-1" />
      <div>
        <strong>
          {daysLeft <= 1
            ? t("ui.folioExpiry.tomorrow", { count: folios })
            : t("ui.folioExpiry.soon", { count: folios, days: daysLeft })}
        </strong>
        <div className="small">
          {t("ui.folioExpiry.detail", { date: formatShortDate(expiresAt) })}
        </div>
      </div>
    </Alert>
  );
};

export default FolioExpiryNotice;
